import { gql } from '@apollo/client';

export const GET_REPORT_BY_DATE = gql`
  query GetReportByDate($checkInId: ID!, $date: Date!) {
    getReport(checkInId: $checkInId, date: $date) {
      id
      reportDate
      checkIn {
        id
        name
        slug
      }
    }
  }
`;

export const GET_REPORT_WITH_RESPONSES = gql`
  query GetReportWithResponses($reportId: ID!, $first: Int, $after: String) {
    report: getReportById(id: $reportId) {
      id
      reportDate
      checkIn {
        id
        name
        slug
      }
    }
    responses: listResponses(reportId: $reportId, first: $first, after: $after) {
      edges {
        node {
          id
          submittedAt
          employee {
            id
            name
            avatarUrl
          }
          answers {
            id
            questionId
            answerText
            extractedData
            question {
              id
              header
              format
              questions
              responseSchema
            }
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const LIST_REPORT_RESPONSES = gql`
  query ListReportResponses($reportId: ID!, $first: Int, $after: String) {
    listResponses(reportId: $reportId, first: $first, after: $after) {
      edges {
        node {
          id
          submittedAt
          employee {
            id
            name
            avatarUrl
          }
          answers {
            id
            questionId
            answerText
            extractedData
            question {
              id
              header
              format
              questions
              responseSchema
            }
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`; 